<template>
  <v-row>
    <v-col cols="12">
      <v-progress-circular color="primary" indeterminate class="ma-4"></v-progress-circular>
      {{message}}
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['message']
}
</script>
